import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const PostCard = ({ post }: any) => {
  return (
    <Link to={`/posts/${post.id}`} className="block">
      <div className="bg-neutral-800 rounded-3xl overflow-hidden h-full">
        <img
          src={post.image}
          alt={post.title}
          className="w-full object-cover p-2 rounded-4xl"
        />
        <div className="p-4">
          <h3 className="text-white text-4xl font-medium mb-2">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.title}</ReactMarkdown>
          </h3>
          {post.content && (
            <div className="markdown-content text-gray-300 mb-3">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown>
            </div>
          )}
          <div className="flex items-center text-md">
            <img src={post.authorUrl} alt={post.author} className="h-6 w-6 rounded-full mr-1" />
            <span className="text-gray-300 ml-1">{post.author}</span>
            <span className="text-gray-500 mx-2">|</span>
            <span className="text-gray-300">{post.date}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

const PostList = ({ posts }: any) => {
  return (
    <div className="ml-6 mr-6 bg-neutral-900/60 rounded-b-3xl">
      <div className="grid grid-cols-1 gap-6 p-4">
        {posts.map((post: any) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default PostList;